import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Video from 'Components/layout/Video';

export default class ContactUsp extends Component {
    static propTypes = {};

    render() {
        return (
            <div className="component-contact-usp">
                <div className="container-fluid v2 medium">
                    <div className="content">
                        <div className="usp-block">
                            <div className="usp-col usp-col-text">
                                <h3 className="block-headline">
                                    OUR STORY
                                </h3>
                                <p className="block-paragraph">
                                    We believe that behind every success story lies another story of collaboration. And that’s been our story ever since we set out in 2011.  It’s simple. We take the collective creativity of 3m storytellers from all over the world and channel it all into telling one story: your brand’s story. The result? Authentic visual content that grabs, sells and most importantly, remains true to your brand.
                                </p>

                            </div>
                            <div className="usp-col usp-col-img">
                                <img className="bg" src={require('./images/contact-usp-4-bg.svg')} />

                            </div>
                        </div>
                        <div className="usp-block">
                            <div className="usp-col usp-col-img">
                                <div className="video-container">
                                    <Video
                                        loop={true}
                                        autoPlay={true}
                                        poster={require('Components/public/contact/Usp/images/contact-usp-2-video-poster.jpg')}
                                        assets={[{
                                            src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-nivea-1.webm',
                                            type: 'video/webm'
                                        }, {
                                            src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-nivea-1.mp4',
                                            type: 'video/mp4'
                                        }]}
                                    />
                                    <img className="video-bg" src={require('./images/contact-usp-2-video-bg.png')} />
                                </div>
                            </div>
                            <div className="usp-col usp-col-text">
                                <h3 className="block-headline">
                                    A picture is worth a 1000 words
                                </h3>
                                <p className="block-paragraph">
                                    …  just as long as it’s on brand. We believe there is no substitute for authentic brand imagery. No generic stock images or videos here. Only custom visual content that tells your brand’s story - and yours alone.
                                </p>
                            </div>
                        </div>


                        <div className="usp-block">
                            <div className="usp-col usp-col-text">
                                <h3 className="block-headline">
                                    No substitute for authenticity
                                </h3>
                                <p className="block-paragraph">
                                    They say a picture is worth a 1000 words. We say, only if it’s on brand! No generic stock images or videos here. Only custom visual content that tells your brand’s story - and nothing less.
                                </p>
                            </div>
                            <div className="usp-col usp-col-img">
                                <div className="video-container">
                                    <Video
                                        loop={true}
                                        autoPlay={true}
                                        poster={require('./images/contact-usp-5-video-poster.jpg')}
                                        assets={[{
                                            src: 'https://videoscdn.foap.co/frontend-static-assets/case-studies/webm_w640-sequence.webm',
                                            type: 'video/webm'
                                        }, {
                                            src: 'https://videoscdn.foap.co/frontend-static-assets/case-studies/mp4_w640-sequence.mp4',
                                            type: 'video/mp4'
                                        }]}
                                    />
                                    <img className="bg" src={require('./images/contact-usp-5-bg.png')} />
                                </div>
                            </div>
                        </div>
                        <div className="usp-block">
                            <div className="usp-col usp-col-img">

                                <img className="bg" src={require('./images/contact-usp-dna.svg')} />

                            </div>
                            <div className="usp-col usp-col-text">
                                <h3 className="block-headline">
                                    It’s in our DNA
                                </h3>
                                <p className="block-paragraph">
                                    Just like you, we are devoted to our craft. And that’s the business of delivering beautiful visual content that wows and performs. We love nothing more than to talk shop til the sun goes down - and then some.
                                    <br /><br />
                                    We don’t live for our craft. We are our craft. We love nothing more than to talk shop til the sun goes down - and then some. More importantly, we are crazy about delivering beautiful visual content that wows and performs.
                                </p>
                            </div>
                        </div>
                        <div className="usp-block">
                            <div className="usp-col usp-col-text">
                                <h3 className="block-headline">
                                    Space to grow
                                </h3>
                                <p className="block-paragraph">
                                    Everyone has a story to tell: big brands, pro photographers and part-time videographers alike. We see it as our mission to lay the ground for brands and content creators, of all shapes and sizes, to collaborate, grow and thrive together.
                                </p>

                            </div>
                            <div className="usp-col usp-col-img">
                                <img className="bg" src={require('./images/contact-usp-space.svg')} />

                            </div>
                        </div>

                        <div className="usp-block">
                            <div className="usp-col usp-col-img">

                                <img className="bg" src={require('./images/contact-usp-connect.svg')} />

                            </div>
                            <div className="usp-col usp-col-text">
                                <h3 className="block-headline">
                                    7 years and counting
                                </h3>
                                <p className="block-paragraph">
                                    That’s how long we’ve been guiding brands to creative greatness. Our creative team’s marketing IQ is only matched by the expertise of our legal & admin experts, ensuring your content not only performs but is legal and secure.
                               </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/contact/Usp/index.js